<template>
    <div class="nav-item" v-if="data">
        <div class="d-flex justify-content-end align-items-center">
            <div class="dropdown wp_HeaderMenuItemsText">
                <button
                    class="btn-my-account dropdown-toggle"
                    type="button"
                    id="authenticatedUserModalBtn1-btnDropdownDemo"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    data-test="authenticatedUserModalBtn1"
                >{{$t(data.myAccountLinkText)}}</button>
                <ul
                    class="dropdown-menu my-account wp_dropDownClassMyAccount"
                    aria-labelledby="btnDropdownDemo"
                >
                    <li
                    v-for="(pathName, index) in data.userRouteListPaths"
                    :key="index"
                    style="cursor: pointer"
                    :data-test="'authenticatedUserModalList'+index"
                    :id="'authenticatedUserModalList'+index"
                    >
                    <router-link
                        :to="$t(pathName.path)"
                        class="dropdown-item"
                        :id="'authenticatedUserModalLink-userprofile-mob-link'+index"
                        :data-test="'authenticatedUserModalLink'+index"
                    >{{$t(pathName.text)}}</router-link>
                    </li>

                    <li
                    @click="logOut"
                    style="cursor: pointer"
                    data-test="authenticatedUserModalLogoutList"
                    id="authenticatedUserModalLogoutList"
                    >
                    <a
                        class="dropdown-item"
                        id="authenticatedUserModalLogoutLink-userLogout-mob-link-header-one"
                        data-test="authenticatedUserModalLogoutLink"
                    >{{$t(data.logoutLinkText)}}</a>
                    </li>
                </ul>
            </div>

        </div>
    </div>
</template>
<script>
import { authenticationApi } from '../../../services/ApiServices/authenticationApi'

export default {
	props: {
		data: {
			type: Object
		}
	},
	methods: {
		logOut () {
			authenticationApi.logOut().then(res => {
				this.$router.push('/')
			})
			// this.$emit('logOutUser')
		},
		userRoutes (to) {
			this.$router.push({
				name: to
			})
		}
	}

}
</script>
